<template>
  <li>
    <div
      class="car not-faded-on-hover"
      :class="{faded: !model.is_available && !model.available_from_is_passed}"
    >
      <div class="car__thumb">
        <span
          v-if="!model.is_available && !model.available_from_is_passed"
          class="badge badge-orange badge-small position-absolute mt-1 ml-1 r-0 badge-vehicle-availability"
        >
          {{ i18n.database.table.vehicles.columns.available_from }}
          <br />
          {{ model.available_from | datetime }}
        </span>
        <VehicleImage :model="model.main_image" />
      </div>

      <div class="car__title">
        <div class="car__thumb__small">
          <VehicleImage :model="model.main_image" />
        </div>

        <span
          class="car__title__segment"
          :style="model.segment && model.segment.color ? {
            'background-color': model.segment.color.hex,
            'color': model.segment.color.text_color + ' !important'
          } : null"
        >{{ model.segment && model.segment.name }}</span>
        <div class="car__title__model">
          {{ model.name }}
          <span
            class="car__title__round"
            :style="{'background-color': getMatchTypeColor()}"
          ></span>
        </div>
        <div
          class="license"
          :class="(model.country ? model.country.iso_3166_2 : 'nl') | lowercase"
        >{{ model.license_plate }}</div>

        <a
          @click="onBookClick"
          class="btn btn-secondary btn-book ml-auto"
          v-if="!model.is_goplanner_vehicle"
        >{{ i18n.app.button.book }}</a>
      </div>

      <div class="car__specs">
        <span v-if="model.fuel_type">{{model.fuel_type.name}}</span>
        <span
          v-if="model.transmission_type"
        >, {{ model.transmission_type.name }}, {{ model.type.name }}</span>
      </div>

      <!-- <New> -->
      <div class="row" v-if="!model.is_goplanner_vehicle">
        <div class="col-4">
          <div class="btn-group" role="group">
            <a
              data-toggle="collapse"
              :href="'#vehicle-details-' + model.id"
              role="button"
              aria-expanded="false"
              aria-controls="porsche1"
              class="d-inline"
            >
              {{ i18n.app.common.more_information }}
              <span class="icon-plus"></span>
            </a>
          </div>
        </div>
        <div class="car__price__info col-8">
          <div class="row">
            <div class="car__price__info__perday col">
              <b>{{ lang.price_per_day }}</b>
              <div :class="{'line-through': !!model.day_price_discounted}">
                {{currencySymbol}} {{model.day_price || '?'}}
              </div>
              <div v-if="model.day_price_discounted">
                {{currencySymbol}} {{model.day_price_discounted || '?'}}
              </div>
            </div>

            <div class="car__price__info__price col">
              <b>{{ lang.deployment_costs }}</b>
              {{currencySymbol}} {{model.deployment_price || '?'}}
            </div>
            <ul
              v-if="model.has_winter_tyres || model.has_tow_bar || model.has_all_season_tyres"
              class="car__price__info__icons col"
            >
              <li v-if="model.has_winter_tyres" :data-tooltip="i18n.app.common.winter_tyres">
                <i class="cs-winterbanden"></i>
              </li>
              <li v-if="model.has_all_season_tyres" :data-tooltip="i18n.app.common.all_season_tyres">
                <i class="cs-winterbanden"></i>
              </li>
              <li v-if="model.has_tow_bar" :data-tooltip="i18n.app.common.tow_bar">
                <i class="cs-trekhaak"></i>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div
      class="collapse car-details"
      :id="'vehicle-details-' + model.id"
      :data-parent="'#company-' + model.depot_id"
    >
      <div class="card card-body">
        <VehicleSpecsList :model="model" />
      </div>
    </div>
  </li>
</template>

<script>
import { ACCESSORY_TAG } from "@/models/Accessory";
import VehicleImage from "./VehicleImage";
import VehicleSpecsList from "./VehicleSpecsList";
import { MatchType } from "../../../../models/Vehicle";

export default {
  name: "vehicle-item",
  props: ["model"],
  components: {
    VehicleImage,
    VehicleSpecsList
  },
  data() {
    return {
      lang: i18n.app.components.vehicle,
      ACCESSORY_TAG: ACCESSORY_TAG,
      currencySymbol: env.CURRENCY_SYMBOL
    };
  },
  filters: {
    distance: value => {
      return value ? parseFloat(value + "").toFixed(1) + " km" : value;
    },
    slice: (value, start, end) => {
      return value ? value.substring(start, end) : value;
    },
    lowercase: val => val.toLowerCase()
  },
  methods: {
    onBookClick() {
      this.$emit("book", this.model);
    },
    getMatchTypeColor() {
      switch (this.model?.match_type) {
        case MatchType.INCLUDED:
          return "green";
        case MatchType.EXCLUDED:
          return "red";
        default:
          return "orange";
      }
    }
  }
};
</script>

<style scoped>
li {
  list-style-type: none;
}
</style>
